import * as PopoverPrimitive from '@radix-ui/react-popover';

export const PopoverRoot = PopoverPrimitive.Root;
PopoverRoot.displayName = PopoverPrimitive.Root.displayName;
